import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ReCAPTCHA from 'react-google-recaptcha';

function ReusableForm(props) {

  const captchaRef = useRef(null);
  function onChange(value) {
    console.log("Captcha value:", value);
    console.log(captchaRef.current)
  }
    return (
      <Container>
        <Form onSubmit={props.formSubmissionHandler}>
          <Row className='d-flex pt-4 justify-content-left'>
            <Col xs='auto'>
              <Form.Group controlId='formClientName'>
                <Form.Label>Name:</Form.Label>
                <Form.Control
                required
                type='text'
                name='clientName'
                // defaultValue=''
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className='d-flex pt-4 justify-content-left'>
            <Col xs='auto'>
              <Form.Group controlId='formClientEmail'>
                <Form.Label>Email Address:</Form.Label>
                <Form.Control
                required
                type='email'
                name='clientEmail'
                placeholder='name@example.com'
                // defaultValue=''
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className='d-flex pt-4 justify-content-center'>
            <Col sm>
              <Form.Group controlId='formClientMessage'>
                <Form.Label>How Can We Help?</Form.Label>
                <Form.Control
                required
                as='textarea'
                rows={3}
                name='clientMessage'
                placeholder='Your message here' 
                // defaultValue=''               
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className='pt-4 justify-content-left'>
            <Col xs='auto'>
            <Button variant='primary' size='xs auto' type='submit' className='btn btn-primary mb-3'>Send It!
            </Button>
            </Col>
          </Row>
          <div className= 'formGroup'>
          <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_CHECKBOX_KEY}
          onChange = {onChange}
          ref={captchaRef}
          />
          </div>
        </Form>
      </Container>
  
    )
  }
  
  ReusableForm.propTypes = {
    formSubmissionHandler: PropTypes.func
  }
  
  export default ReusableForm
